var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9998 24C12.3198 24 13.3998 22.92 13.3998 21.6H8.59981C8.59981 22.92 9.67981 24 10.9998 24ZM18.7998 16.8V10.2C18.7998 6.48 16.2798 3.48 12.7998 2.64V1.8C12.7998 0.84 11.9598 0 10.9998 0C10.0398 0 9.19981 0.84 9.19981 1.8V2.64C5.71981 3.48 3.19981 6.48 3.19981 10.2V16.8L0.799805 19.2V20.4H21.1998V19.2L18.7998 16.8Z",
    fill: "#101010"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.ed4257351e1179b94974c71a2f599fe3.svg";
export { ForwardRef as ReactComponent };